export default __webpack_public_path__ + "static/media/emailer-thumbnails.6c905ebf.jpg";